import { Component, OnInit, ViewChild, TemplateRef, EventEmitter, AfterViewInit } from '@angular/core';
import { BehaviorSubject, filter, map, pairwise, Subscription, throttleTime } from 'rxjs';
import { LookupService } from '../../services/lookup.service';
import { Task } from "../../models/task/task";
import { QueueService } from '../../services/queue.service';
import { ConfigService } from '../../services/config-service.service';
import { TaskService } from '../../services/task-service.service';
import { TokenStorageService } from '../../services/token-storage.service';
import { queueTypes, ReferTaskTypes, TASKSTATUS_SUCCESSFUL, TASKSTATUS_UNSUCCESSFUL, TEAMQUEUETASKS } from '../../../assets/constants';
import { FilterService } from '../../services/filter-service.service';
import { AutoUnsubscribe } from '../../shared/decorators/auto-unsubscribe.decorator';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AppSettings } from '../../shared/appsettings';

@AutoUnsubscribe

export class TaskIdData
{
    taskId!: number
}

export class TaskQueueUpdate {
  taskIdList!:TaskIdData[];
  owner!:string | null;
  groupId!: number | null;
  currentUser!: string;
}

@Component({
    selector: 'app-team-queue-tasks',
    templateUrl: './team-queue-tasks.component.html',
    styleUrls: ['./team-queue-tasks.component.scss'],
    standalone: false
})
export class TeamQueueTasksComponent implements OnInit, AfterViewInit {
  @ViewChild('filterTaskDialogTemplate') filterTaskTemplate: TemplateRef<any> | undefined;
  @ViewChild('teamTasksView', {static: false}) cdkVirtualScrollViewport!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport) virtualScroll!: CdkVirtualScrollViewport;

  selectedTasks: Task[] = [];
  refreshTitleText = 'Refresh task queue';
  teamTasks!: Task[];
  teamTasksFiltered!: Task[];
  userGroupIds!: number[];
  userName!: string;
  totalTasks = 0;
  successId!: number[];
  unsuccessfulId!: number[];
  sub!: Subscription;
  allTasksList = new BehaviorSubject<Task[]>([]);
  filterType = TEAMQUEUETASKS;
  searchPageNumber = 0;
  maxQueueCount = 0;
  //Select or deselect all checkboxes
  allSelected: boolean = false;
  allTasks: Task[] = [];
    countMessage = '';
  selectOrDeselectAll() {
    var value = this.allSelected ? true : false;
    if (value) {
      this.selectedTasks = [];
      this.statusFilter();
      this.teamTasks.forEach(element => {
        element.checked = value;
        this.taskSelectedToggle(element);
      });
    }
    else {
      this.teamTasks.forEach(element => {element.checked = false});
      this.selectedTasks = [];
    }
  }

  filterBadgeData = { text: '', count: 0 }
  openDialogEvent = new EventEmitter<boolean>();

  constructor(private queueService: QueueService, 
    private configService: ConfigService, 
    private taskService: TaskService, 
    private tokenService: TokenStorageService, 
    private lookupService: LookupService, 
    private filterService: FilterService,
    private appSettings: AppSettings  ) {
      this.maxQueueCount = this.appSettings.maxQueueCount;
     }
  
  openFilterDialog() {
    this.openDialogEvent.emit(true);
  }

  referDialogEvent(event: any) {
    const taskList = this.selectedTasks.map(t => {
      let element: TaskIdData = {taskId: t.taskId};
      return element;
    });
    let updateParams = new TaskQueueUpdate();
    switch (event.referType) {
      case ReferTaskTypes.MY_ASSIGNMENT:
        this.selectedTasks.forEach(t => {
          const index = this.teamTasks.findIndex(x => x.taskId == t.taskId);
          this.teamTasks.splice(index,1);
        });
        this.queueService.transferItems(queueTypes.MEMBER_TASK_QUEUE, this.selectedTasks);
        updateParams = { taskIdList: taskList, owner: this.userName, groupId: null, currentUser: this.userName }
        break;
      case ReferTaskTypes.TEAM_MEMBER:
        updateParams = { taskIdList: taskList, owner: event.teamMemberId, groupId: null, currentUser: this.userName }
        break;
      case ReferTaskTypes.WORK_QUEUE:
        updateParams = { taskIdList: taskList, owner: null, groupId: event.workQueueTypeId, currentUser: this.userName }
        break;
    }
    this.taskService.updateTaskQueues(updateParams);
    this.resetCheckedTasks(updateParams);
  }

  ngOnInit(): void {
    this.sub = this.lookupService.LookupData.subscribe(data => {
      this.successId = data.filter(t => t.lookupStandardValue.toLowerCase() === TASKSTATUS_SUCCESSFUL.toLowerCase()).map(o => o.lookupValueID);
      this.unsuccessfulId = data.filter(t => t.lookupStandardValue.toLowerCase() === TASKSTATUS_UNSUCCESSFUL.toLowerCase()).map(o => o.lookupValueID);
      if (this.teamTasks) {
        this.statusFilter();
      }
    })
    
    this.sub.add(this.taskService.teamTaskList.subscribe(data => {
      if (data && data.length > 0) {
        this.allTasks = [...data];
        var pagedData = this.getPagedTaskQueueByGroup(0,this.maxQueueCount);
        if (pagedData) {
          this.teamTasks = pagedData;
          this.teamTasks.sort((a, b) => this.queueService.sortTasks(a, b));

          this.allTasksList.next(this.teamTasks);
          this.countMessage = `${this.teamTasks.length.toLocaleString()} of ${this.allTasks.length.toLocaleString()}`;
        }
      }
    }));

    this.sub.add(this.configService.userGroupList.subscribe(data => {
      if (data.length > 0) {
        this.userGroupIds = data.map(d => d.queueId);
          this.taskService.getTaskListByGroupID(this.userGroupIds);
      }
    }));
    this.sub.add(this.taskService.taskUpdated.subscribe(data => {
      if (data) {
        this.taskService.getTaskListByGroupID(this.userGroupIds);
      }
    }));
    this.sub.add(this.filterService.badgeDataBs.subscribe(bd => {
      if (bd.filter_type == TEAMQUEUETASKS) {
        this.filterBadgeData = bd;
      }
    }));
    if (this.successId && this.unsuccessfulId && this.teamTasks) {
      this.statusFilter();
      this.totalTasks = this.teamTasks.length;
    }
    this.userName = this.tokenService.getUser().profile.preferred_username;
  }

  getPagedTaskQueueByGroup(skipRows: number, takeRows: number) {
      if (this.allTasks) {
        let queueList = [...this.allTasks];
        queueList = this.filterService.applySessionFilter(queueList, TEAMQUEUETASKS);
        queueList = queueList.filter(t => t.hidden == false);
        this.totalTasks = queueList.length;
        let totalRows = skipRows + takeRows;
        if (skipRows > queueList.length) {
          return null;
        }
        if (totalRows > queueList.length) {
          takeRows = queueList.length - skipRows;
        }
        return queueList.slice(skipRows, takeRows + skipRows);
      } else {
        return null;
      }
    }

  ngAfterViewInit() {
      this.virtualScroll.elementScrolled().pipe(
        map(() => this.virtualScroll.measureScrollOffset('bottom')),
        pairwise(),
        filter(([y1, y2]) => (y2 < y1 && y2 < 140)),
        throttleTime(200)
      ).subscribe(() => {
        this.searchPageNumber++;
          let pagedData = this.getPagedTaskQueueByGroup(this.searchPageNumber*this.maxQueueCount,this.maxQueueCount);
          if (pagedData) {
          let tasks = this.teamTasks.concat(pagedData);
        this.teamTasks = [...tasks];
        this.teamTasks.sort((a, b) => this.queueService.sortTasks(a, b));
        //this.tasks = [...this.filterService.applySessionFilter(this.tasks, MYQUEUETASKS)];
        //this.statusFilter();
        this.allTasksList.next(this.teamTasks);
        //this.totalTasks = this.tasks.filter(t => t.hidden == false).length;
        this.countMessage = `${this.teamTasks.length.toLocaleString()} of ${this.totalTasks.toLocaleString()}`;
      }
          
      })
    }

  calculateContainerHeight(): string {
    if (!this.teamTasks){
      return '';
    }
    const numberOfItems = this.teamTasks.length;
    // This should be the height of your item in pixels
    const itemHeight = 123;
    // The final number of items you want to keep visible
    const visibleItems = 20;
  
    setTimeout(() => {
      // Makes CdkVirtualScrollViewport to refresh its internal size values after 
      // changing the container height. This should be delayed with a "setTimeout"
      // because we want it to be executed after the container has effectively 
      // changed its height. Another option would be a resize listener for the 
      // container and call this line there but it may requires a library to detect 
      // the resize event.
  
      this.cdkVirtualScrollViewport.checkViewportSize();
    }, 300);
  
    // It calculates the container height for the first items in the list
    // It means the container will expand until it reaches `200px` (20 * 10)
    // and will keep this size.
    if (numberOfItems <= visibleItems) {
      return `${itemHeight * numberOfItems}px`;
    }
  
    // This function is called from the template so it ensures the container will have 
    // the final height if number of items are greater than the value in "visibleItems".
    return `${itemHeight * visibleItems}px`;
  }

  statusFilter() {
    this.teamTasks = this.teamTasks.filter(t=> (!this.successId.includes(t.statusId) && !this.unsuccessfulId.includes(t.statusId)));
  }

  taskSelectedToggle(e: any) {
    if (e.checked && e.taskId != undefined && this.teamTasks.findIndex(t => t.taskId == e.taskId) != undefined) {
      this.selectedTasks.push(this.teamTasks.find(t => t.taskId == e.taskId)!);
    }
    else {
      const selectedIndex = this.selectedTasks.findIndex(t => t.taskId == e.taskId);
      this.selectedTasks.splice(selectedIndex,1);
    }
  }

  sortQueue() {
    this.teamTasks.sort((a,b) => this.queueService.sortTasks(a, b));
  }

  refreshQueue() {
    this.taskService.getTaskListByGroupID(this.userGroupIds);
  }
  
  resetCheckedTasks(list: TaskQueueUpdate):void {
    list.taskIdList.map(t => t.taskId).map(t => {
      const task = this.teamTasks.find(tt => tt.taskId === t);
      if (task != undefined)  task.checked = false;
    });
    this.selectedTasks = [];
    this.allSelected = false;
  }

  dialogEvent(tasks: Task[]) {
    let takeRows = 0;
    this.teamTasks = tasks.filter(a => a.hidden == false);
    let totalCount = this.teamTasks.length.toLocaleString();
    let totalRows = this.maxQueueCount;
      if (this.maxQueueCount > tasks.length) {
        //do nothing
      }
      if (totalRows > this.teamTasks.length) {
        takeRows = this.teamTasks.length - this.maxQueueCount;
      }
      this.teamTasks = [...this.teamTasks.slice(0, (takeRows + this.maxQueueCount))];

    //this.statusFilter();
    //this.totalTasks = this.tasks.filter(a => a.hidden == false).length
    this.countMessage = `${this.teamTasks.length.toLocaleString()} of ${totalCount}`;
    this.allTasksList.next(this.teamTasks);
  }

  displayCountEvent(count:number) {
    this.totalTasks = count;
  }
}
